import {showBeError as _showBeError, ErrorOptions, Response} from '@fl/cmsch-fe-library';
import {Action} from 'redux';

import {t} from 'app/translations';

type Options = Omit<ErrorOptions, 'getMessage'>;

const translate = t('beErrors');

/**
 * Converts a backend error response into a user-facing Redux action payload.
 *
 * @param response - The backend response to inspect.
 * @param title - The title used in the error message.
 * @param options - Optional display options forwarded to the shared error helper.
 * @returns A Redux action or action list describing the error to show.
 */
export const showBeError = (
    response: Response<unknown>,
    title: string,
    options?: Options,
): Action | Array<Action> =>
    _showBeError(response, title, {
        getMessage: translate,
        ...options,
    });
